export default "__VITE_ASSET__GSR9lfXY__"